import type { RegistrationStatus, RegistrationStatusRequest } from "@/modules/events/types/eventDetailsApi"

import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { REGISTRATION_STATUS_ENDPOINT } from "@/modules/events/constants/api"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"
import { toCamelCaseKeys } from "@/modules/format/object/toCamelCaseKeys"

export const getRegistrationStatus = async (params: RegistrationStatusRequest): Promise<RegistrationStatus> => {
  const { eventId } = params

  return fetcher(REGISTRATION_STATUS_ENDPOINT, {
    requestInit: {
      body: JSON.stringify({ event_id: eventId }),
      method: "POST",
    },
    serviceDomain: "APIGW_IN_KRAKEND_API",
  })
    .then(getResultFromResponse<RegistrationStatus>({ transformResult: toCamelCaseKeys<RegistrationStatus> }))
    .catch(handleFetchError(REGISTRATION_STATUS_ENDPOINT, params))
}
